module.exports = __webpack_public_path__ + "img/banner.7f24c9f5.png";